import React from "react"

const NoopComponent = props =>
  React.Children.count(props.children) > 0 ? <>{props.children}</> : null

/**
 * common teaser structure template
 *
 * @param {{
 *  elements: object,
 *  Wrapper: React.ComponentType<any>,
 *  Content: React.ComponentType<any>
 * }} param0
 */
const TeaserTemplate = ({
  elements: { title, body, trivia, asset } = {},
  Wrapper = NoopComponent,
  Content = NoopComponent,
  ...props
}) => {
  return (
    <Wrapper {...props}>
      {title}
      <Content {...props}>
        {asset}
        {body}
      </Content>
      {trivia}
    </Wrapper>
  )
}

export default TeaserTemplate
